import { render, staticRenderFns } from "./swiper-item.vue?vue&type=template&id=fef0309c&scoped=true"
import script from "./swiper-item.vue?vue&type=script&lang=ts"
export * from "./swiper-item.vue?vue&type=script&lang=ts"
import style0 from "./swiper-item.vue?vue&type=style&index=0&id=fef0309c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef0309c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCustomImage: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/custom-image.vue').default})
